const partDetailsSelection = `recordingPartDiagnostics {
  preprocess { expectedParts succeeded failed pending unreported known }
  recompose { expectedParts succeeded failed pending unreported known }
  anotherOrientationPending wholeFileCoverageVerified
}`;

const showRecordingPartDetails = (role, flag = process.env.REACT_APP_RECORDING_PART_DETAILS_CUSTOMER_VISIBLE) =>
  role === 'admin' || flag === 'true';

// Read-only schema compatibility, never retries a mutation or an authorization error.
const legacyRecordingPartDetailsRequest = (request, response) => {
  if (typeof request?.query !== 'string' || !/^\s*query RecordingsSpecific\b/.test(request.query) ||
      !request.query.includes(partDetailsSelection) || !Array.isArray(response?.errors) || !response.errors.length ||
      response.errors.some(error => !/^Cannot query field "recordingPartDiagnostics" on type "Room"\./.test(error?.message || ''))) return null;
  // Keep this shared CommonJS helper free of CRA's ESM object-spread helper.
  return Object.assign({}, request, { query: request.query.replace(partDetailsSelection, '') });
};
module.exports = { partDetailsSelection, showRecordingPartDetails, legacyRecordingPartDetailsRequest };
